/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export default class Assert {
    public static notNull<T>(wert?: T | null, meldung = "Wert ist null") {
        if (wert === null || typeof wert === "undefined") {
            throw new Error(meldung);
        }

        return wert;
    }
}
